export interface V2TrustRowProps {
  /** The claims, already translated. Rendered in order, one cyan dot each. */
  items: readonly string[];
  /** The list's accessible name. */
  label: string;
  /** Defaults to `v2-trust-row`; the sign-in shell keeps its historical `auth-trust-row`. */
  testId?: string;
}

/** The row of short assurances under a V2 card. */
export function V2TrustRow({ items, label, testId = "v2-trust-row" }: V2TrustRowProps) {
  return (
    <ul
      className="text-auth-mute dark:text-auth-on-ink-mute mx-auto mt-5 flex max-w-[44ch] flex-wrap items-center justify-center gap-x-5 gap-y-1.5 text-[12px]"
      aria-label={label}
      data-testid={testId}
    >
      {items.map((item) => (
        <li key={item} className="inline-flex items-center gap-1.5">
          <span className="bg-auth-glow-cyan/80 size-1.5 rounded-full" aria-hidden="true" />
          {item}
        </li>
      ))}
    </ul>
  );
}
